import { Module, ResourceModule } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { createReducer, on } from '@ngrx/store';
import {
	cleanResources,
	deleteModule,
	deleteModuleError,
	deleteModuleSuccess,
	deleteResourceModule,
	deleteResourceModuleError,
	deleteResourceModuleSuccess,
	deleteVersionsModule,
	deleteVersionsModuleFailure,
	deleteVersionsModuleSuccess,
	getAllModule,
	getAllModuleSuccess,
	getModule,
	getModuleError,
	getModuleSuccess,
	getResourcesModule,
	getResourcesModuleError,
	getResourcesModuleSuccess,
	getResourcesSearchModuleError,
	getSearchModule,
	getSearchModuleSuccess,
	getVersionsModule,
	getVersionsModuleFailure,
	getVersionsModuleSuccess,
	postModule,
	postModuleError,
	postModuleSuccess,
	postResourceModule,
	postResourceModuleError,
	postResourceModuleSuccess,
	postVersionsModule,
	postVersionsModuleFailure,
	postVersionsModuleSuccess,
	putVersionsModule,
	putVersionsModuleFailure,
	putVersionsModuleSuccess,
	updateModule,
	updateModuleError,
	updateModuleSuccess,
	updateResourceModule,
	updateResourceModuleError,
	updateResourceModuleSuccess,
} from './systems-module.action';
import { initialStateModule } from './systems-module.state';
import adapterDataPagination from '../../../Domain/Adapters/pagination.adapter';
import {
	getResourcesSearchModule,
	getResourcesSearchModuleSuccess,
	getSearchModuleError,
} from './systems-module.action';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';

export const reducer = createReducer(
	initialStateModule,
	on(getModuleSuccess, (state, { module, pagination }) => ({
		...state,
		modules: [...state.modules, ...module],
		pagination: adapterDataPagination(pagination),
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(cleanResources, (state) => ({
		...state,
		modules: [],
		pagination: {} as DataPagination,
		dataResources: {} as ResourceModule,
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(getAllModuleSuccess, getSearchModuleSuccess, (state, { module }) => ({
		...state,
		modules: module,
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(updateModuleSuccess, (state, { module }) => ({
		...state,
		loading: false,
		loadingResources: false,
		modules: state.modules.map((data) => {
			return data.pk === module.pk ? module : data;
		}),
		error: null,
	})),
	on(deleteModuleSuccess, (state, { module }) => {
		const item = [...state.modules];
		let modules: Module[] = [];
		item.forEach((moduleSelected) => {
			if (moduleSelected.sk != module.sk) {
				modules.push(moduleSelected);
			}
		});
		return {
			...state,
			modules: modules,
			error: null,
			loading: false,
			loadingResources: false,
		};
	}),
	on(postModuleSuccess, (state, { module }) => ({
		...state,
		modules: [module, ...state.modules],
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(getResourcesModuleSuccess, (state, { resource, pagination, pk }) => ({
		...state,
		dataResources: {
			resource,
			paginationIni: pagination,
			pagination: adapterDataPagination(pagination),
		},
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(getVersionsModule, deleteVersionsModule, postVersionsModule, putVersionsModule, (state) => ({
		...state,
		loadingVersions: true,
	})),
	on(getVersionsModuleSuccess, (state, { versions, pagination, ids }) => ({
		...state,
		loadingVersions: false,
		dataVersions: {
			paginationIni: pagination,
			pagination: adapterDataPagination(pagination),
			versions: versions,
		},
	})),
	on(putVersionsModuleSuccess, (state, { version }) => {
		const versions: Versions[] = state.dataVersions.versions.map((item) =>
			item.pk === version.pk && item.sk === version.sk ? version : item
		);
		return {
			...state,
			dataVersions: {
				...state.dataVersions,
				versions,
			},
			error: null,
			loading: false,
			loadingVersions: false,
		};
	}),
	on(deleteVersionsModuleSuccess, (state, { ids }) => {
		const versions = [...state.dataVersions.versions];
		ids.forEach((versionItem) => {
			const IndexVersion = versions.findIndex(
				(item) => item.pk === versionItem.pk && item.sk === versionItem.sk
			);
			versions.splice(IndexVersion, 1);
		});
		return {
			...state,
			loadingVersions: false,
			dataVersions: {
				paginationIni: state.dataVersions.paginationIni,
				pagination: adapterDataPagination(
					state.dataVersions.paginationIni,
					state.dataVersions.versions.length,
					-ids.length,
					state.dataVersions.pagination.total,
					state.dataVersions.pagination.pageTo
				),
				versions,
			},

			error: null,
		};
	}),
	on(postVersionsModuleSuccess, (state, { version }) => {
		return {
			...state,
			dataVersions: {
				versions: [...state.dataVersions.versions, version],
				paginationIni: state.dataVersions.paginationIni,
				pagination: adapterDataPagination(
					state.dataVersions.paginationIni,
					state.dataVersions.versions.length,
					+1,
					state.dataVersions.pagination.total,
					state.dataVersions.pagination.pageTo
				),
			},
			loadingVersions: false,
		};
	}),

	on(postResourceModuleSuccess, (state, { resource, pk, sk }) => {
		return {
			...state,
			error: null,
			dataResources: {
				resource: [...state.dataResources.resource, resource],
				paginationIni: state.dataResources.paginationIni,
				pagination: adapterDataPagination(
					state.dataResources.paginationIni,
					state.dataResources.resource.length,
					+1,
					state.dataResources.pagination.total,
					state.dataResources.pagination.pageTo
				),
			},
			loading: false,
			loadingResources: false,
		};
	}),
	on(updateResourceModuleSuccess, (state, { resource, pk, sk }) => {
		const resourcesData: Resource[] = state.dataResources.resource.map((resourceItem) => {
			return resourceItem.pk === resource.pk && resourceItem.sk === resource.sk
				? resource
				: resourceItem;
		});
		return {
			...state,
			dataResources: {
				...state.dataResources,
				resource: resourcesData,
			},
			error: null,
			loading: false,
			loadingResources: false,
		};
	}),
	on(deleteResourceModuleSuccess, (state, { ids, pk, sk }) => {
		const resources = [...state.dataResources.resource];

		ids.forEach((resourceItem) => {
			const IndexRosource = resources.findIndex(
				(item) => item.pk === resourceItem.pk && item.sk === resourceItem.sk
			);
			resources.splice(IndexRosource, 1);
		});

		return {
			...state,
			loading: false,
			loadingResources: false,
			dataResources: {
				paginationIni: state.dataResources.paginationIni,
				pagination: adapterDataPagination(
					state.dataResources.paginationIni,
					state.dataResources.resource.length,
					-ids.length,
					state.dataResources.pagination.total,
					state.dataResources.pagination.pageTo
				),
				resource: resources,
			},

			error: null,
		};
	}),

	on(getResourcesSearchModuleSuccess, (state, { resource, pagination, pk }) => ({
		...state,
		dataResources: {
			resource,
			paginationIni: pagination,
			pagination: adapterDataPagination(
				pagination ? pagination : state.dataResources.paginationIni
			),
		},
		error: null,
		loading: false,
		loadingResources: false,
	})),
	on(
		getModuleError,
		postModuleError,
		updateModuleError,
		deleteModuleError,
		getResourcesModuleError,
		postResourceModuleError,
		updateResourceModuleError,
		getResourcesSearchModuleError,
		deleteResourceModuleError,
		getSearchModuleError,
		getVersionsModuleFailure,
		postVersionsModuleFailure,
		putVersionsModuleFailure,
		deleteVersionsModuleFailure,
		(state, { error }) => ({
			...state,
			error: error.error.errorMessage,
			loading: false,
			loadingResources: false,
			loadingVersions: false,
		})
	),
	on(getModule, postModule, updateModule, deleteModule, getAllModule, getSearchModule, (state) => ({
		...state,
		loading: true,
		loadingResources: false,
	})),
	on(
		getResourcesModule,
		updateResourceModule,
		deleteResourceModule,
		postResourceModule,
		getResourcesSearchModule,
		(state) => ({
			...state,
			loading: false,
			loadingResources: true,
		})
	)
);
